import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('PartNumber');

const PartNumber = (props) => {
    const { selectedPartNumber, className, messages, loading } = props;
    const skeleton = loading ? 'loading' : undefined;

    return (
        <div className={bem(null, skeleton, className)}>
            {messages.product.productCode()}{' '}
            <span className={bem('number')} dir="ltr">
                {/* Allows spacing to be determined in brand styling */}
                {[...selectedPartNumber].map((char, i) => (
                    <span key={i}>{char}</span>
                ))}
            </span>
        </div>
    );
};

PartNumber.propTypes = {
    selectedPartNumber: PropTypes.string.isRequired,
    className: PropTypes.string,
    loading: PropTypes.bool,
    messages: PropTypes.shape({
        product: PropTypes.shape({
            productCode: PropTypes.func.isRequired,
        }).isRequired,
    }),
};

export default PartNumber;
